document.addEventListener('DOMContentLoaded', () => {
    const descriptions = document.querySelectorAll('.description');
    const readMoreLinks = document.querySelectorAll('.readMoreLink');
    const readLessLinks = document.querySelectorAll('.readLessLink');
    const dotsElements = document.querySelectorAll('.dots');

    const setInitialState = (description, readMoreLink, readLessLink, dots, maxHeight) => {
        if (description.scrollHeight > maxHeight) {
            description.style.height = `${maxHeight}px`;
            description.style.overflow = 'hidden';
            description.classList.add('expandable');
            readMoreLink.style.display = 'inline';
            dots.style.display = 'inline';
        } else {
            readMoreLink.style.display = 'none';
            dots.style.display = 'none';
            description.classList.add('expanded');
        }
        readLessLink.style.display = 'none';
    };

    const toggleDescription = (description, readMoreLink, readLessLink, dots, maxHeight, expand) => {
        if (expand) {
            description.style.height = 'auto';
            description.style.overflow = 'visible';
            readMoreLink.style.display = 'none';
            readLessLink.style.display = 'inline';
            dots.style.display = 'none';
            description.classList.add('expanded');
        } else {
            description.style.height = `${maxHeight}px`;
            description.style.overflow = 'hidden';
            readMoreLink.style.display = 'inline';
            readLessLink.style.display = 'none';
            dots.style.display = 'inline';
            description.classList.remove('expanded');
        }
    };

    const attachEventListeners = (readMoreLink, readLessLink, description, dots, maxHeight) => {
        readMoreLink.addEventListener('click', (event) => {
            event.preventDefault();
            toggleDescription(description, readMoreLink, readLessLink, dots, maxHeight, true);
        });

        readLessLink.addEventListener('click', (event) => {
            event.preventDefault();
            toggleDescription(description, readMoreLink, readLessLink, dots, maxHeight, false);
        });
    };

    descriptions.forEach((description, index) => {
        const readMoreLink = readMoreLinks[index];
        const readLessLink = readLessLinks[index];
        const dots = dotsElements[index];
        const lineHeight = parseInt(window.getComputedStyle(description).lineHeight);
        const maxHeight = lineHeight * 6; // 6 lines
        
        setInitialState(description, readMoreLink, readLessLink, dots, maxHeight);
        attachEventListeners(readMoreLink, readLessLink, description, dots, maxHeight);
    });

    const isMobile = window.innerWidth <= 768;
});